// Below are built-in components that are available in the app, it's recommended to keep them as is

import { BYOCWrapper, NextjsContentSdkComponent, FEaaSWrapper } from '@sitecore-content-sdk/nextjs';
import { Form } from '@sitecore-content-sdk/nextjs';

// end of built-in components
import * as PartialDesignDynamicPlaceholdersitecore from 'src/components/PartialDesignDynamicPlaceholder.sitecore';
import * as Registrationsitecore from 'src/components/helpers/Registration/Registration.sitecore';
import * as Preamblesitecore from 'src/components/helpers/Molecules/Preamble/Preamble.sitecore';
import * as Ctasitecore from 'src/components/helpers/Atoms/Cta/Cta.sitecore';
import * as SubscriptionCentersitecore from 'src/components/authorable/shared/userprofile/SubscriptionCenter/SubscriptionCenter.sitecore';
import * as SignUpsitecore from 'src/components/authorable/shared/userprofile/SignUp/SignUp.sitecore';
import * as ResetPasswordsitecore from 'src/components/authorable/shared/userprofile/ResetPassword/ResetPassword.sitecore';
import * as MyAccountsitecore from 'src/components/authorable/shared/userprofile/MyAccount/MyAccount.sitecore';
import * as Loginsitecore from 'src/components/authorable/shared/userprofile/Login/Login.sitecore';
import * as ForgotPasswordsitecore from 'src/components/authorable/shared/userprofile/ForgotPassword/ForgotPassword.sitecore';
import * as EmailUnsubscribesitecore from 'src/components/authorable/shared/userprofile/EmailUnsubscribe/EmailUnsubscribe.sitecore';
import * as PearCommerceProductsitecore from 'src/components/authorable/shared/third-party/PearCommerceProduct/PearCommerceProduct.sitecore';
import * as BazaarVoiceReviewsQuestionssitecore from 'src/components/authorable/shared/third-party/BazaarVoiceReviewsQuestions/BazaarVoiceReviewsQuestions.sitecore';
import * as SkipNavsitecore from 'src/components/authorable/shared/site-structure/SkipNav/SkipNav.sitecore';
import * as MainLayoutsitecore from 'src/components/authorable/shared/site-structure/MainLayout/MainLayout.sitecore';
import * as RecipeDetailsitecore from 'src/components/authorable/shared/recipe/RecipeDetail/RecipeDetail.sitecore';
import * as ProductDetailsitecore from 'src/components/authorable/shared/product/ProductDetail/ProductDetail.sitecore';
import * as NewsletterSignupsitecore from 'src/components/authorable/shared/newsletter-signup/NewsletterSignup.sitecore';
import * as SocialBarsitecore from 'src/components/authorable/shared/navigation/SocialBar/SocialBar.sitecore';
import * as SearchDropDownsitecore from 'src/components/authorable/shared/navigation/SearchDropDown/SearchDropDown.sitecore';
import * as Headersitecore from 'src/components/authorable/shared/navigation/Header/Header.sitecore';
import * as Footersitecore from 'src/components/authorable/shared/navigation/Footer/Footer.sitecore';
import * as Breadcrumbsitecore from 'src/components/authorable/shared/navigation/Breadcrumb/Breadcrumb.sitecore';
import * as VerticalVideositecore from 'src/components/authorable/shared/content/VerticalVideo/VerticalVideo.sitecore';
import * as TableOfContentssitecore from 'src/components/authorable/shared/content/TableOfContents/TableOfContents.sitecore';
import * as SearchResultssitecore from 'src/components/authorable/shared/content/SearchResults/SearchResults.sitecore';
import * as PullQuotesitecore from 'src/components/authorable/shared/content/PullQuote/PullQuote.sitecore';
import * as PromoBannersitecore from 'src/components/authorable/shared/content/PromoBanner/PromoBanner.sitecore';
import * as PreambleLinkListsitecore from 'src/components/authorable/shared/content/PreambleLinkList/PreambleLinkList.sitecore';
import * as Imagesitecore from 'src/components/authorable/shared/content/Image/Image.sitecore';
import * as Iframesitecore from 'src/components/authorable/shared/content/Iframe/Iframe.sitecore';
import * as Herositecore from 'src/components/authorable/shared/content/Hero/Hero.sitecore';
import * as FeatureTextOnlysitecore from 'src/components/authorable/shared/content/FeatureTextOnly/FeatureTextOnly.sitecore';
import * as FeatureImageAndTextsitecore from 'src/components/authorable/shared/content/FeatureImageAndText/FeatureImageAndText.sitecore';
import * as FeatureFancysitecore from 'src/components/authorable/shared/content/FeatureFancy/FeatureFancy.sitecore';
import * as EmbeddedVideositecore from 'src/components/authorable/shared/content/EmbeddedVideo/EmbeddedVideo.sitecore';
import * as EmailBoxsitecore from 'src/components/authorable/shared/content/EmailBox/EmailBox.sitecore';
import * as ContentTabssitecore from 'src/components/authorable/shared/content/ContentTabs/ContentTabs.sitecore';
import * as ContentBlocksitecore from 'src/components/authorable/shared/content/ContentBlock/ContentBlock.sitecore';
import * as Badgesitecore from 'src/components/authorable/shared/content/Badge/Badge.sitecore';
import * as AlertBannersitecore from 'src/components/authorable/shared/content/AlertBanner/AlertBanner.sitecore';
import * as Accordionsitecore from 'src/components/authorable/shared/content/Accordion/Accordion.sitecore';
import * as ThreePackCardssitecore from 'src/components/authorable/shared/card-listing/ThreePackCards/ThreePackCards.sitecore';
import * as SideBySideContainersitecore from 'src/components/authorable/shared/card-listing/SideBySideContainer/SideBySideContainer.sitecore';
import * as MixedMediaGridsitecore from 'src/components/authorable/shared/card-listing/MixedMediaGrid/MixedMediaGrid.sitecore';
import * as GeneralCardsitecore from 'src/components/authorable/shared/card-listing/GeneralCard/GeneralCard.sitecore';
import * as ContentListCardsitecore from 'src/components/authorable/shared/card-listing/ContentListCard/ContentListCard.sitecore';
import * as ContentGridsitecore from 'src/components/authorable/shared/card-listing/ContentGrid/ContentGrid.sitecore';
import * as CategoryTilessitecore from 'src/components/authorable/shared/card-listing/CategoryTiles/CategoryTiles.sitecore';
import * as CarouselStaticsitecore from 'src/components/authorable/shared/card-listing/Carousel/CarouselStatic.sitecore';
import * as Carouselsitecore from 'src/components/authorable/shared/card-listing/Carousel/Carousel.sitecore';
import * as AdvancedContentGridsitecore from 'src/components/authorable/shared/card-listing/AdvancedContentGrid/AdvancedContentGrid.sitecore';
import * as NewsletterSignupModalsitecore from 'src/components/authorable/shared/NewsletterSignUpModal/NewsletterSignupModal.sitecore';

export const componentMap = new Map<string, NextjsContentSdkComponent>([
  ['BYOCWrapper', BYOCWrapper],
  ['FEaaSWrapper', FEaaSWrapper],
  ['Form', Form],
  ['PartialDesignDynamicPlaceholder', { ...PartialDesignDynamicPlaceholdersitecore }],
  ['Registration', { ...Registrationsitecore }],
  ['Preamble', { ...Preamblesitecore }],
  ['Cta', { ...Ctasitecore }],
  ['SubscriptionCenter', { ...SubscriptionCentersitecore }],
  ['SignUp', { ...SignUpsitecore }],
  ['ResetPassword', { ...ResetPasswordsitecore }],
  ['MyAccount', { ...MyAccountsitecore }],
  ['Login', { ...Loginsitecore }],
  ['ForgotPassword', { ...ForgotPasswordsitecore }],
  ['EmailUnsubscribe', { ...EmailUnsubscribesitecore }],
  ['PearCommerceProduct', { ...PearCommerceProductsitecore }],
  ['BazaarVoiceReviewsQuestions', { ...BazaarVoiceReviewsQuestionssitecore }],
  ['SkipNav', { ...SkipNavsitecore }],
  ['MainLayout', { ...MainLayoutsitecore }],
  ['RecipeDetail', { ...RecipeDetailsitecore }],
  ['ProductDetail', { ...ProductDetailsitecore }],
  ['NewsletterSignup', { ...NewsletterSignupsitecore }],
  ['SocialBar', { ...SocialBarsitecore }],
  ['SearchDropDown', { ...SearchDropDownsitecore }],
  ['Header', { ...Headersitecore }],
  ['Footer', { ...Footersitecore }],
  ['Breadcrumb', { ...Breadcrumbsitecore }],
  ['VerticalVideo', { ...VerticalVideositecore }],
  ['TableOfContents', { ...TableOfContentssitecore }],
  ['SearchResults', { ...SearchResultssitecore }],
  ['PullQuote', { ...PullQuotesitecore }],
  ['PromoBanner', { ...PromoBannersitecore }],
  ['PreambleLinkList', { ...PreambleLinkListsitecore }],
  ['Image', { ...Imagesitecore }],
  ['Iframe', { ...Iframesitecore }],
  ['Hero', { ...Herositecore }],
  ['FeatureTextOnly', { ...FeatureTextOnlysitecore }],
  ['FeatureImageAndText', { ...FeatureImageAndTextsitecore }],
  ['FeatureFancy', { ...FeatureFancysitecore }],
  ['EmbeddedVideo', { ...EmbeddedVideositecore }],
  ['EmailBox', { ...EmailBoxsitecore }],
  ['ContentTabs', { ...ContentTabssitecore }],
  ['ContentBlock', { ...ContentBlocksitecore }],
  ['Badge', { ...Badgesitecore }],
  ['AlertBanner', { ...AlertBannersitecore }],
  ['Accordion', { ...Accordionsitecore }],
  ['ThreePackCards', { ...ThreePackCardssitecore }],
  ['SideBySideContainer', { ...SideBySideContainersitecore }],
  ['MixedMediaGrid', { ...MixedMediaGridsitecore }],
  ['GeneralCard', { ...GeneralCardsitecore }],
  ['ContentListCard', { ...ContentListCardsitecore }],
  ['ContentGrid', { ...ContentGridsitecore }],
  ['CategoryTiles', { ...CategoryTilessitecore }],
  ['CarouselStatic', { ...CarouselStaticsitecore }],
  ['Carousel', { ...Carouselsitecore }],
  ['AdvancedContentGrid', { ...AdvancedContentGridsitecore }],
  ['NewsletterSignupModal', { ...NewsletterSignupModalsitecore }],
]);

export default componentMap;
